import { render } from "./OrcamentoComponent.vue?vue&type=template&id=f62595b0&scoped=true"
import script from "./OrcamentoComponent.vue?vue&type=script&lang=js"
export * from "./OrcamentoComponent.vue?vue&type=script&lang=js"

import "./OrcamentoComponent.vue?vue&type=style&index=0&id=f62595b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f62595b0"]])

export default __exports__